export default "__VITE_ASSET__CCdjpIXf__"